import React, { useMemo } from 'react';
import { QSelect, type QSelectOption } from 'components/QDropdowns';
import type { DateRangeType } from './types';

type ShortcutsSelectProps = {
  shortcutItems: DateRangeType[];
  selectedId: string;
  handleSelect: (id: string) => void;
};

function ShortcutsSelect({ shortcutItems, selectedId, handleSelect }: ShortcutsSelectProps) {
  const options = useMemo(
    (): QSelectOption[] =>
      shortcutItems.map((item, index) => ({
        value: item.id,
        label: item.label,
        id: item.id,
        dividerBefore: index > 0 && Boolean(shortcutItems[index - 1]?.dividerAfter),
      })),
    [shortcutItems],
  );

  return (
    <QSelect
      id='date-range-shortcuts'
      value={selectedId}
      onChange={handleSelect}
      options={options}
      size='small'
      width={220}
    />
  );
}

export default ShortcutsSelect;
